import { render, staticRenderFns } from "./content-type-3.vue?vue&type=template&id=02553ea6&scoped=true&"
import script from "./content-type-3.vue?vue&type=script&lang=js&"
export * from "./content-type-3.vue?vue&type=script&lang=js&"
import style0 from "./content-type-3.vue?vue&type=style&index=0&id=02553ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02553ea6",
  null
  
)

export default component.exports